import { ApiValidationErrorViewModel } from "@/viewModels/apiErrorViewModel";

/**
 * APIバリデーションエラー周りの処理。
 * APIのエラーレスポンスの中には、ユーザーの入力に起因しないエラー(`publishCookieId`が`Null`の時など)が格納されているケースがあるため、そうではないことを保証するための処理。
 */
export default class ApiValidationErrorUtil {
	/**
	 * talkRoomPost 時のユーザー起因のバリデーションエラー種類。
	 */
	private static validationTarget_talkRoomPost = ["contents", "nickName"];
	/**
	 * 受け取ったエラーオブジェクトの中に、ユーザー起因のバリデーションエラーが含まれているかをチェックする。(トークルーム投稿版)
	 * @param object APIエラーオブジェクト
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public static isValidateObject_talkRoomPost(object: any): boolean {
		// 対象オブジェクトがAPIエラーオブジェクトであるかチェック
		const error = this.isApiValidationResponse(object) ? (object as ApiValidationErrorViewModel) : null;
		// APIエラーオブジェクトでなければfalse
		if (!error) {
			return false;
		}

		return this.isContainUserValidationTarget(error, this.validationTarget_talkRoomPost);
	}

	/**
	 * talkRoomNoticeMail 時のユーザー起因のバリデーションエラー種類。
	 */
	private static validationTarget_talkRoomNoticeMail = ["mailAddress"];
	/**
	 * 受け取ったエラーオブジェクトの中に、ユーザー起因のバリデーションエラーが含まれているかをチェックする。(トークルームメール通知版)
	 * @param object APIエラーオブジェクト
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public static isValidateObject_talkRoomNoticeMail(object: any): boolean {
		// 対象オブジェクトがAPIエラーオブジェクトであるかチェック
		const error = this.isApiValidationResponse(object) ? (object as ApiValidationErrorViewModel) : null;
		// APIエラーオブジェクトでなければfalse
		if (!error) {
			return false;
		}

		return this.isContainUserValidationTarget(error, this.validationTarget_talkRoomNoticeMail);
	}

	/**
	 * replyPost 時のユーザー起因のバリデーションエラー種類。
	 */
	private static validationTarget_replyPost = ["reply.Contents", "reply.NickName"];
	/**
	 * 受け取ったエラーオブジェクトの中に、ユーザー起因のバリデーションエラーが含まれているかをチェックする。(リプライ投稿版)
	 * @param object APIエラーオブジェクト
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public static isValidateObject_replyPost(object: any): boolean {
		// 対象オブジェクトがAPIエラーオブジェクトであるかチェック
		const error = this.isApiValidationResponse(object) ? (object as ApiValidationErrorViewModel) : null;
		// APIエラーオブジェクトでなければfalse
		if (!error) {
			return false;
		}

		return this.isContainUserValidationTarget(error, this.validationTarget_replyPost);
	}

	/**
	 * 対象オブジェクトがAPIエラーオブジェクトかどうかをチェックする。
	 * @param object 対象オブジェクト
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private static isApiValidationResponse(object: any): boolean {
		if (!object.message) return false;
		if (!object.code) return false;
		if (!object.details) return false;
		if (object.details.length < 1) return false;

		return true;
	}

	/**
	 * 対象APIバリデーションエラーオブジェクト内部に、ユーザー起因のバリデーションエラーが存在するかどうかをチェックする。
	 * @param object 対象APIバリデーションエラーオブジェクト
	 * @param userValidationTarget ユーザー起因のバリデーションエラー`target`名
	 * @param `true`:存在する / `false`:存在しない
	 */
	private static isContainUserValidationTarget(error: ApiValidationErrorViewModel, userValidationTarget: string[]): boolean {
		let result = false;
		userValidationTarget.forEach((validationTarget) => {
			error.details.forEach((e) => {
				if (e.target === validationTarget) {
					result = true;
				}
			});
		});
		return result;
	}
}
